module.exports = __webpack_public_path__ + "img/permission.23cf1205.svg";